import { Cell } from '@/components/Bicester/Table/Cells';
import { Button } from '@/components/Bicester';
import _ from 'lodash';
import React from 'react';

// 入场时间Cell
export const InsideCell = ({
  rowData,
  dataKey,
  content,
  disabled = false,
  isHide = false,
  handle,
  revokeHandle,
  ...props
}: any) => {
  const data = _.get(rowData, dataKey);
  const hideBtn = _.isFunction(isHide) ? isHide(rowData) : isHide;

  return (
    <Cell {...props}>
      {data ? (
        <div className="flex">
          <span>{data}</span>
        </div>
      ) : hideBtn ? null : (
        <Button
          appearance="link"
          disabled={_.isFunction(disabled) ? disabled(rowData) : disabled}
          onClick={handle.bind(null, rowData)}
          style={{ color: '#73D8DA' }}
        >
          {content}
        </Button>
      )}
    </Cell>
  );
};
